import React from 'react';
import {get as _get} from 'lodash';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';

import {CircularProgress, Backdrop} from '@ui';
import {GetClientByBookmaker} from '@graphql/client/query';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import {convertToInt} from '@utils/helpers';

import {ClientRedirect} from './ClientRedirect';

export function ClientRedirectByBookmaker({
    history,
    match,
}) {
    const {
        data: {
            clientByBookmaker,
        } = {},
        error,
        loading: isDataLoading = true,
    } = useQueryCustom({
        query: GetClientByBookmaker,
        options: {
            variables: {
                bookmakerId: convertToInt(match.params.id),
            },
        },
    });

    return (isDataLoading && !error)
        ? (
            <Backdrop open inverted>
                <CircularProgress />
            </Backdrop>
        )
        : (
            <ClientRedirect
                history={history}
                clientId={_get(clientByBookmaker, 'id', null)}
            />
        );
}

ClientRedirectByBookmaker.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }),
};

export default withRouter(ClientRedirectByBookmaker);
